// meta.js
export const META = {
    title: "Erom Studio | Design. Develop. Deliver.",
    description: "Explore Erom Studio’s web and app development services, where we create stunning websites and easy-to-use apps. Let us turn your ideas into reality with simple, effective digital solutions.",
    author: "Erom Studio",
    url: "https://eromstudio.in",
    image: "/og_meta.png"
};
